/**
 * Template: Product - Gift card
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Gift card template.
 *
 * @namespace product
 */
import { load } from '@shopify/theme-sections';
import ProductForm from '~/components/product-form';
import '~/sections/recommended-products';
document.addEventListener('DOMContentLoaded', () => {
  /**
   * DOM selectors.
   */
  const selectors = {
    siteHeaderContainer: '[js-site-header="container"]',
    templateProductContainer: '[js-template-product="container"]'
  };
  /**
  * DOM node selectors.
  */

  const nodeSelectors = {
    siteHeaderContainer: document.querySelector(selectors.siteHeaderContainer),
    templateProductContainer: document.querySelector(selectors.templateProductContainer)
  };
  /**
   * initial styling set up for pdp body
   */

  function adjustProductNavStyle() {
    const navHeight = nodeSelectors.siteHeaderContainer.offsetHeight;
    nodeSelectors.templateProductContainer.style.marginTop = "".concat(navHeight, "px");
  }

  load('recommended-products');
  adjustProductNavStyle();
  ProductForm({
    container: 'container',
    enableSwatches: true
  }).init();
});